import { Typography } from 'antd';
import { useTranslation } from "react-i18next";
import { FaTelegramPlane, FaWhatsapp } from 'react-icons/fa';

const { Link } = Typography;

const ContactUs = () => {
    const { t } = useTranslation();
    return (
        <div>
            <div className="mt-4 pt-4 border-t border-gray-200 text-center">
                <p className="text-left text-sm text-gray-500">{t("needHelp")}</p>
                <div className="mt-2 flex items-center">
                    <FaWhatsapp size={20} color="black" />
                    <Link
                        href="https://wtsp.cc/79095248808"
                        className="text-left text-sm text-black ml-2"
                        target="_blank"
                        rel="noopener noreferrer"
                        style={{ color: 'black' }}
                    >
                        {t("waSupportLink")}
                    </Link>
                </div>
                <div className="mt-2 flex items-center">
                    <FaTelegramPlane size={20} color="black" />
                    <Link
                        href="https://t.me/laone_order_bot"
                        className="text-left text-sm text-black ml-2"
                        target="_blank"
                        rel="noopener noreferrer"
                        style={{ color: 'black' }}
                    >
                        {t("tgSupportLink")}
                    </Link>
                </div>
            </div>
        </div>
    );
};

export default ContactUs;